import React from "react";
import "./ScanBar.scss";
const ScanBar = ({}) => {
  return <div className="scanBar"></div>;
};

export default ScanBar;
